import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { forwardRef } from 'react';
import styled, { css, ThemeProvider } from 'styled-components';
import { bordersTemplate, spacingsTemplate, typographyTemplate, useToken } from '@equinor/eds-utils';
import { topbar } from './TopBar.tokens.js';
import { jsx } from 'react/jsx-runtime';
import { Paper } from '../Paper/Paper.js';
import { useEds } from '../EdsProvider/eds.context.js';

var _excluded = ["children", "elevation", "sticky"];
var StyledTopBar = styled(Paper).withConfig({
  displayName: "TopBar__StyledTopBar",
  componentId: "sc-1yj236q-0"
})(function (_ref) {
  var theme = _ref.theme,
    $sticky = _ref.$sticky;
  return css(["height:", ";background:", ";box-sizing:border-box;display:grid;grid-column-gap:", ";grid-template-columns:auto 1fr auto;grid-template-areas:'left center right';align-items:center;", " ", ";", " ", ""], theme.height, theme.background, theme.spacings.left, bordersTemplate(theme.border), spacingsTemplate(theme.spacings), typographyTemplate(theme.typography), $sticky && css(["position:sticky;top:0;z-index:1100;"]));
});
var TopBar = /*#__PURE__*/forwardRef(function TopBar(_ref2, ref) {
  var children = _ref2.children,
    _ref2$elevation = _ref2.elevation,
    elevation = _ref2$elevation === void 0 ? 'none' : _ref2$elevation,
    _ref2$sticky = _ref2.sticky,
    sticky = _ref2$sticky === void 0 ? true : _ref2$sticky,
    props = _objectWithoutProperties(_ref2, _excluded);
  var _useEds = useEds(),
    density = _useEds.density;
  var token = useToken({
    density: density
  }, topbar);
  var rest = _objectSpread(_objectSpread({}, props), {}, {
    ref: ref
  });
  return /*#__PURE__*/jsx(ThemeProvider, {
    theme: token,
    children: /*#__PURE__*/jsx(StyledTopBar, _objectSpread(_objectSpread({
      forwardedAs: 'header',
      elevation: elevation,
      $sticky: sticky
    }, rest), {}, {
      children: children
    }))
  });
});

// TopBar.displayName = 'eds-topbar'

export { TopBar };
